var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_52",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m64.832,64.41l-3.53,21.86c-.21,1.47-1.48,2.56-2.96,2.56h-16.68c-1.49,0-2.75-1.09-2.97-2.56l-3.52-21.86c-.53-3.27-.33-6.62.59-9.8.41-1.41,1.04-2.75,1.85-3.95.82-1.21,1.82-2.28,2.98-3.19l1-.79c1.55-1.21,2.98-3.8,3.17-5.76l1.751-28.481c.016-.264.235-.469.499-.469l.548-.127c1.605-.372,3.275-.371,4.88.001l.542.126c.264,0,.483.206.499.469l1.751,28.481c.2,1.96,1.63,4.55,3.18,5.76l1,.79c1.16.91,2.16,1.98,2.98,3.19.81,1.2,1.44,2.54,1.84,3.95.92,3.18,1.13,6.53.6,9.8Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m46.162,17.127l.729-.137c2.055-.385,4.163-.385,6.218,0l.729.137",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }